import {
    ChangeDetectionStrategy,
    Component,
    input,
    model,
    output,
    ViewEncapsulation,
} from "@angular/core";
import { CerrixIconButtonComponent } from "@app/shared/atoms/cerrix-icon-button/cerrix-icon-button.component";

@Component({
    selector: "app-cerrix-link-item-row",
    imports: [CerrixIconButtonComponent],
    templateUrl: "./cerrix-link-item-row.component.html",
    styleUrl: "./cerrix-link-item-row.component.scss",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        "[class.selected]": "selected()",
        "[class.readonly]": "readonly()",
    },
})
export class CerrixLinkItemRowComponent {
    readonly label = input.required<string>();

    /** Names the details button for assistive technology. */
    readonly openAriaLabel = input.required<string>();

    readonly selected = model(false);

    /** Keeps the row rendered and focusable, but ignores a pick. */
    readonly readonly = input(false);

    /** The details button is independent of the row: it never picks the row. */
    readonly detailsRequested = output<void>();

    protected toggle(): void {
        if (this.readonly()) {
            return;
        }

        this.selected.set(!this.selected());
    }
}
